import { Component, HostListener, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';
import { Stockitem } from '../../../../../interfaces/stockitem';
import { BrandService } from '../../../../../services/brandservice';
import { UserService } from '../../../../../services/user';



interface BrandMobileItem extends Stockitem {
  id: any;
  brandname_en?: string;
  brandname_ar?: string;
  brand_description_en?: string;
  brand_description_ar?: string;
  brand_logo?: string | null;
  showMoreEn?: boolean;
  showMoreAr?: boolean;
}

@Component({
  selector: 'app-allbrandsmobile',
  templateUrl: './allbrandsmobile.component.html',
  styleUrl: './allbrandsmobile.component.scss'
})
export class AllbrandsmobileComponent implements OnInit {

  allData: BrandMobileItem[] = [];

  contentReady = true;
  loadingMore = false;
  noData = false;

  currentPage = 1;
  perPage = 10;
  lastPage = 1;
  stockTotal = 0;
  hasMoreData = true;

  isAr = localStorage.getItem('language') === 'ar';

  accountType!: string;
  isAdmin = false;
  isSubAdmin = false;

  addImage = false;
  selectedFile: File | null = null;
  imagePreview: string | null = null;
  selectedBrandId: string | null = null;

  constructor(
    private router: Router,
    private _brand: BrandService,
    private _userService: UserService
  ) {}

  ngOnInit(): void {
    this._userService.getAccountType().subscribe({
      next: (data) => {
        this.accountType = data['user_type'];
        this.isAdmin = this.accountType === '1' || this.accountType === '10';
        this.isSubAdmin = this.accountType === '6';

        this.resetAndLoad();
      },
      error: (error) => {
        console.error(error);
        this.contentReady = false;
      }
    });
  }

  @HostListener('window:scroll', [])
  onWindowScroll(): void {
    const scrollPosition =
      window.pageYOffset ||
      document.documentElement.scrollTop ||
      document.body.scrollTop ||
      0;

    const windowHeight = window.innerHeight;
    const pageHeight = document.documentElement.scrollHeight;
    const bottomReached = scrollPosition + windowHeight >= pageHeight - 120;

    if (bottomReached) {
      this.loadMore();
    }
  }

  resetAndLoad(): void {
    this.currentPage = 1;
    this.lastPage = 1;
    this.stockTotal = 0;
    this.hasMoreData = true;
    this.allData = [];
    this.getAllbrands(1, false);
  }

  getAllbrands(page: number = 1, append: boolean = false): void {
    if (append) {
      this.loadingMore = true;
    } else {
      this.contentReady = true;
    }

    this._brand.getAll(localStorage.getItem('posId'), this.perPage, page).subscribe({
      next: (data) => {
        const newData: BrandMobileItem[] = Array.isArray(data?.['data'])
          ? data['data']
          : [];

        this.currentPage = Number(data?.['current_page'] || page);
        this.lastPage = Number(data?.['last_page'] || 1);
        this.stockTotal = Number(data?.['total'] || newData.length || 0);

        this.allData = append ? [...this.allData, ...newData] : newData;

        this.hasMoreData = this.currentPage < this.lastPage;
        this.noData = this.allData.length === 0;

        this.contentReady = false;
        this.loadingMore = false;
      },
      error: (error) => {
        console.error(error);
        this.contentReady = false;
        this.loadingMore = false;
      }
    });
  }

  loadMore(): void {
    if (this.contentReady || this.loadingMore || !this.hasMoreData) return;

    this.getAllbrands(this.currentPage + 1, true);
  }

  toggleDescription(element: BrandMobileItem, lang: 'en' | 'ar'): void {
    if (lang === 'en') {
      element.showMoreEn = !element.showMoreEn;
      return;
    }

    element.showMoreAr = !element.showMoreAr;
  }

  onImageSelected(event: Event): void {
    const input = event.target as HTMLInputElement;

    if (!input.files?.[0]) return;

    this.selectedFile = input.files[0];

    const reader = new FileReader();
    reader.onload = () => {
      this.imagePreview = reader.result as string;
    };

    reader.readAsDataURL(this.selectedFile);
  }

  submitImage(): void {
    if (!this.selectedFile || !this.selectedBrandId) return;

    const formData = new FormData();
    formData.append('image', this.selectedFile);
    formData.append('brand_id', this.selectedBrandId);

    /*
      حط هنا ميثود رفع الصورة الموجودة عندك في BrandService.
      مثال لو عندك method اسمها uploadLogo:

      this._brand.uploadLogo(formData).subscribe({
        next: () => {
          this.close();
          this.resetAndLoad();
        },
        error: (err) => console.error(err)
      });
    */
  }

  openAddImage(brandId: string): void {
    this.selectedBrandId = brandId;
    this.selectedFile = null;
    this.imagePreview = null;
    this.addImage = true;
  }

  close(): void {
    this.addImage = false;
    this.selectedFile = null;
    this.imagePreview = null;
    this.selectedBrandId = null;
  }

  fixurl(imagePath: string | null | undefined): string {
    if (!imagePath) return '/assets/no-image.png';
    if (imagePath.startsWith('http')) return imagePath;

    return `https://backendproduction.blueboxpet.com/storage/app/public/${imagePath}`;
  }

  deleteitem(id: string): void {
    Swal.fire({
      title: this.isAr ? 'متأكد؟' : 'Are You Sure?',
      showCancelButton: true,
      confirmButtonText: this.isAr ? 'أيوه' : 'YES',
      cancelButtonText: this.isAr ? 'لا' : 'NO'
    }).then((result) => {
      if (!result.isConfirmed) return;

      this.contentReady = true;

      this._brand.delete(id).subscribe({
        next: () => {
          this.resetAndLoad();
        },
        error: (err) => {
          console.error(err);
          this.contentReady = false;
        }
      });
    });
  }

  edit(itemobj: any): void {
    this.router.navigate(['/createbrand'], { queryParams: itemobj });
  }

}